<template>
    <BaseModal
        v-model:open="open"
        panel-classes="p-xl"
    >
        <template #headline>
            <slot name="headline"/>
        </template>
        <template #default>
            <div class="text-left">
                <div
                    v-if="$hasSlotContent($slots.subHeadline)"
                    class="mb-l"
                >
                    <slot name="subHeadline"/>
                </div>
                <div
                    data-qa="gdpr body"
                    class="o-modalGdpr__gdprTextAllowedTags"
                >
                    <slot/>
                </div>
            </div>
        </template>
    </BaseModal>
</template>

<script setup>
import BaseModal from '../../headless/BaseModal.vue';

const open = defineModel('open', { type: Boolean });

</script>

<style lang="scss">
@use '~@karriereat/global-styles/scss/settings/spacing';
@use '~@karriereat/global-styles/scss/tools/typo';

.o-modalGdpr {
    &__gdprTextAllowedTags {
        // Needed for stylings for the pushed gdpr texts of the company.
        span > p {
            margin-top: spacing.$k-spacing--l;
        }

        br {
            margin-top: 0; // Firefox allows margins on line-breaks.
        }

        h1,
        h2 {
            @include typo.k-typo-m();
        }

        strong,
        b {
            font-weight: 500;
        }

        em,
        i {
            font-style: italic;
        }

        u {
            text-decoration: underline;
        }

        ul,
        ol {
            padding-left: spacing.$k-spacing--xl;
        }

        ul {
            list-style-type: disc;
        }

        ol {
            list-style-type: decimal;
        }
    }
}
</style>
